import { injectable } from 'inversify';

import axios, { AxiosPromise } from 'axios';

import Auth from '../interfaces/Auth';

@injectable()
export default class AuthProvider implements Auth {

  http;

  constructor() {
    this.http = axios.create({
      baseURL: process.env.API_URL
    });
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async login(email, password) {
    return await this.http.post('/login', {
      email: email,
      password: password,
    });
  }

  // /**
  //  * @returns {AxiosPromise<any>}
  //  */
  // public async loginToOldWebSite(email, password) {
  //   return await this.http.post(process.env.OLD_LOGIN_URL, {
  //     email: email,
  //     password: password,
  //   });
  // }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async resetPassword(email) {
    return await this.http.post('/reset-password', {
      email: email
    });
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async resetTokenValidate(token) {
    return await this.http.get('/reset-password/' + token);
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  public async resetPasswordConformation(email, token, password, passwordConformation) {
    return await this.http.post('/reset-password-new', {
      email: email,
      token: token,
      password: password,
      password_confirmation: passwordConformation,
    });
  }

  public logout() {
    localStorage.removeItem('token');
    window.location.href = process.env.PATH_HOME;
  }

  public authenticated(token) {
    localStorage.setItem('token', token);
  }

  public isAuthenticated() {
    return localStorage.getItem('token') ? true : false;
  }

  public token() {
    return localStorage.getItem('token');
  }
}
